module.exports = __webpack_public_path__ + "static/img/6.6023b56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/sp/6.png
// module id = W0X3
// module chunks = 0